import { DiffChunk, DiffType } from './types';

export function myersDiff<T>(a: T[], b: T[]): DiffChunk[] {
  if (a.length === 0 && b.length === 0) return [];
  if (a.length === 0) return b.map((v) => ({ type: 'add' as DiffType, value: String(v) }));
  if (b.length === 0) return a.map((v) => ({ type: 'remove' as DiffType, value: String(v) }));

  const N = a.length;
  const M = b.length;
  const MAX = N + M;

  const V = new Map<number, number>();
  V.set(1, 0);

  const trace: Map<number, number>[] = [];

  for (let D = 0; D <= MAX; D++) {
    for (let k = -D; k <= D; k += 2) {
      let x: number;

      if (k === -D || (k !== D && (V.get(k - 1) ?? 0) < (V.get(k + 1) ?? 0))) {
        x = V.get(k + 1) ?? 0;
      } else {
        x = (V.get(k - 1) ?? 0) + 1;
      }

      let y = x - k;

      while (x < N && y < M && a[x] === b[y]) {
        x++;
        y++;
      }

      V.set(k, x);

      if (x >= N && y >= M) {
        trace.push(new Map(V));
        return backtrace(trace, a, b, D);
      }
    }
    trace.push(new Map(V));
  }

  return [];
}

function backtrace<T>(trace: Map<number, number>[], a: T[], b: T[], D: number): DiffChunk[] {
  const result: DiffChunk[] = [];
  let x = a.length;
  let y = b.length;

  for (let d = D; d > 0; d--) {
    const V = trace[d];
    const k = x - y;

    let prevK: number;
    if (k === -d || (k !== d && (V.get(k - 1) ?? 0) < (V.get(k + 1) ?? 0))) {
      prevK = k + 1;
    } else {
      prevK = k - 1;
    }

    const prevX = trace[d - 1].get(prevK) ?? 0;
    const prevY = prevX - prevK;

    while (x > prevX && y > prevY) {
      result.unshift({ type: 'equal' as DiffType, value: String(a[x - 1]) });
      x--;
      y--;
    }

    if (d > 0) {
      if (x === prevX) {
        result.unshift({ type: 'add' as DiffType, value: String(b[y - 1]) });
        y--;
      } else {
        result.unshift({ type: 'remove' as DiffType, value: String(a[x - 1]) });
        x--;
      }
    }
  }

  while (x > 0 && y > 0) {
    result.unshift({ type: 'equal' as DiffType, value: String(a[x - 1]) });
    x--;
    y--;
  }

  return result;
}
